<template>
    <div class="mx-3 my-3">
      <div v-if="showPart === 0">
        <h3>Exit Questionnaire</h3>
            <p class="text-left">To complete the study, please answer the following questions
            to provide us with additional information about the study. Your
            answers to these questions will <b>not</b> impact whether or not
            you are paid, so
             <span style="color: red;">please be as honest and detailed as possible.</span></p>
        </div>
    <div v-if="showPart === 1" class="text-left">
        <h3>Question 1 of 4</h3>
         <b-form-group
        label="Did you notice any bugs or issues
         with the website while you were doing the task?">
            <b-form-radio v-model="questions[0]" name="bugs-radios" value="0">
                No</b-form-radio>
            <b-form-radio v-model="questions[0]" name="bugs-radios" value="1">
                Yes</b-form-radio>
            <b-form-radio v-model="questions[0]" name="bugs-radios" value="2">
                Unsure</b-form-radio>
        </b-form-group>
        <div v-if="questions[0] === '1' || questions[0] === '2'">
            <label for="bugsNotes">If Yes/Unsure, please decribe.</label>
            <b-form-textarea
                v-model="notes[0]"
                rows="3"
                max-rows="6"
            ></b-form-textarea>
            <small class="form-text text-muted">
                Add any details that you think might be helpful.</small>
        </div>
    </div>
    <div v-if="showPart === 2" class="text-left">
        <h3>Question 2 of 4</h3>
        <b-form-group
         label="Did you use any tricks or strategies to help you
          remember the data?">
            <b-form-radio v-model="questions[1]" name="strategy-radios" value="0">
                No</b-form-radio>
            <b-form-radio v-model="questions[1]" name="strategy-radios" value="1">
                Yes</b-form-radio>
            <b-form-radio v-model="questions[1]" name="strategy-radios" value="2">
                Unsure</b-form-radio>
        </b-form-group>
        <div v-if="questions[1] === '1' || questions[1] === '2'">
            <label for="strategyNotes">If Yes/Unsure, please decribe.</label>
            <b-form-textarea
                v-model="notes[1]"
                rows="3"
                max-rows="6"
            ></b-form-textarea>
            <small class="form-text text-muted">
                Add any details that you think might be helpful.</small>
        </div>
    </div>
    <div v-if="showPart === 3" class="text-left">
        <h3>Question 3 of 4</h3>
        <b-form-group
         label="During the study, did you write down any of
          the numbers to help you remember them?">
            <b-form-radio v-model="questions[2]" name="data-radios" value="0">
                No</b-form-radio>
            <b-form-radio v-model="questions[2]" name="data-radios" value="1">
                Yes</b-form-radio>
            <b-form-radio v-model="questions[2]" name="data-radios" value="2">
                Unsure</b-form-radio>
        </b-form-group>
        <div v-if="questions[2] === '1' || questions[2] === '2'">
            <label for="dataNotes">If Yes/Unsure, please decribe.</label>
            <b-form-textarea
                v-model="notes[2]"
                rows="3"
                max-rows="6"
            ></b-form-textarea>
            <small class="form-text text-muted">
                Add any details that you think might be helpful.</small>
        </div>
    </div>
    <div v-if="showPart === 4" class="text-left">
        <h3>Question 4 of 4</h3>
        <div>
            <label for="generalNotes">
                Is there anything else you would like us to know about the study?</label>
            <b-form-textarea
                v-model="notes[3]"
                rows="3"
                max-rows="6"
            ></b-form-textarea>
            <small class="form-text text-muted">
                Add any details that you think might be helpful.</small>
        </div>
    </div>
    <div>
        <b-button
        class="rounded-pill"
        variant="info"
        v-if="showNext"
        @click="goNext">
        Next</b-button>
    </div>
    <alert class="m-3" :message="msg" v-if="showMsg"></alert>
    </div>
</template>

<style scoped>
h3{
  text-align: center;
}
</style>
<script>
import axios from 'axios';
import Alert from '../Other/Alert.vue';

export default {
  name: 'ExitQuestion',
  data() {
    return {
      showPart: 0,
      showNext: true,
      showMsg: false,
      msg: 'Please answer the question before go next!',
      questions: ['', '', ''],
      notes: ['', '', '', ''],
    };
  },
  watch: {
    showPart(newVal) {
      localStorage.showPart = newVal;
    },
  },
  components: {
    alert: Alert,
  },
  methods: {
    goNext() {
      localStorage.setItem('questions', JSON.stringify(this.questions));
      localStorage.setItem('notes', JSON.stringify(this.notes));
      if (this.showPart === 0) {
        this.showMsg = false;
        this.showPart += 1;
      } else if (this.showPart <= 3) {
        if (this.questions[this.showPart - 1] === '' || (this.questions[this.showPart - 1] !== '0' && this.notes[this.showPart - 1] === '')) {
          this.showMsg = true;
        } else {
          this.showMsg = false;
          this.showPart += 1;
        }
      } else if (this.notes[this.showPart - 1] === '') {
        this.showMsg = true;
      } else {
        this.showMsg = false;
        this.onSubmit();
      }
    },
    onSubmit() {
      const path = `${this.$hostname}/submit-return/${this.userID}`;
      const payload = {
        questions: this.questions,
        notes: this.notes,
      };
      axios
        .put(path, payload)
        .then((res) => {
          console.log(res.data.isLoggedIn);
          if (!res.data.isLoggedIn) {
            this.$router.push({ name: 'Login' });
          } else {
            this.$router.push({ name: 'Finish' });
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
                this.showMsg = true;
          this.msg = 'Server Error';
          console.error(error);
        });
    },
  },
  created() {
    this.userID = localStorage.userID;
    if (localStorage.getItem('showPart')) {
      try {
        this.showPart = parseInt(localStorage.showPart, 10);
      } catch (e) {
        localStorage.removeItem('showPart');
      }
    }
    if (localStorage.getItem('questions')) {
      try {
        this.questions = JSON.parse(localStorage.getItem('questions'));
      } catch (e) {
        localStorage.removeItem('questions');
        this.showPart = 0;
      }
    }
    if (localStorage.getItem('notes')) {
      try {
        this.notes = JSON.parse(localStorage.getItem('notes'));
      } catch (e) {
        localStorage.removeItem('notes');
      }
    }
  },
};
</script>
